import formContact from './form-contact';
import form0b2c6191 from './form-0b2c6191';
import form0b2c6192 from './form-0b2c6192';
import form0b2c6193 from './form-0b2c6193';
import form0b2c6194 from './form-0b2c6194';
import form0b2c6195 from './form-0b2c6195';
import form0b2c6196 from './form-0b2c6196';
import form0b2c6197 from './form-0b2c6197';
import form0b2c6198 from './form-0b2c6198';

export default {
    formContact,
    form0b2c6191,
    form0b2c6192,
    form0b2c6193,
    form0b2c6194,
    form0b2c6195,
    form0b2c6196,
    form0b2c6197,
    form0b2c6198,
}
